import * as complianceSettings from '../redux/selectors/complianceSettings';

const languageCodes = {
  1026: 'bulgarian',
  1050: 'croatian',
  1029: 'czech',
  1030: 'danish',
  1043: 'dutch-netherlands',
  1061: 'estonian',
  1035: 'finnish',
  1036: 'french',
  1031: 'german',
  1032: 'greek',
  1038: 'hungarian',
  1040: 'italian',
  1062: 'latvian',
  1063: 'lithuanian',
  1082: 'maltese',
  1045: 'polish',
  1048: 'romanian',
  1051: 'slovakian',
  1060: 'slovenian',
  1034: 'spanish',
  1053: 'swedish',
  1055: 'turkish-cypress'
};

export function getPrivacyPolicyLink(language, hash) {
  let url = 'http://www.cvent.com/en/privacy-policy-global.shtml';

  if (languageCodes[language]) {
    url = `http://www.cvent.com/en/privacy-policy/privacy-policy-global-${languageCodes[language]}.shtml`;
  }

  if (hash) {
    url = `${url}#${hash}`;
  }

  return url;
}

export function getPlannerPrivacyPolicyLink(state) {
  if (complianceSettings.shouldShowPrivacyPolicy(state)) {
    return [
      {
        url: complianceSettings.getPrivacyPolicyUrl(state),
        text: complianceSettings.getPrivacyPolicyLinkText(state)
      }
    ];
  }

  return [];
}
